import React, { useMemo } from "react";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { isAccountType } from "@common/constants/domains/accounting/helpers";
import { Picker } from "@design-system/Picker/Picker.lib";
import { FormikField } from "@components/forms/FormikField/FormikField";
import { buildAccountTypeTree } from "./buildAccountTypeTree";
import styles from "./AccountTypeSelectField.module.scss";

interface Props {
    name: string;
    value: AccountType | null;
    onChange: (type: AccountType) => void;
    types: readonly AccountType[];
    label: string;
    description?: string;
    placeholder?: string;
    disabled?: boolean;
}

// Callers must clear parentGroupId when the type changes.
export const AccountTypeSelectField: React.FC<Props> = ({
    name,
    value,
    onChange,
    types,
    label,
    description,
    placeholder,
    disabled = false,
}) => {
    const treeItems = useMemo(() => buildAccountTypeTree(types), [types]);

    const handleChange = (next: string | null): void => {
        if (next === null || !isAccountType(next) || next === value) {
            return;
        }
        onChange(next);
    };

    return (
        <FormikField
            name={name}
            label={label}
            labelTooltip={description}
            control="button"
            className={styles.field}
        >
            <Picker.Select
                items={treeItems}
                value={value}
                onValueChange={handleChange}
                disabled={disabled}
                searchable
                autoHighlight
                placeholder={placeholder}
                defaultExpandAll
                trigger={<Picker.Button variant="primary" size="xl" block />}
            />
        </FormikField>
    );
};
